import React from 'react';
import PropTypes from 'prop-types';
import { Paper } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/styles';
import DataDisplay from './DataDisplayJourney';
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
const useStyles = makeStyles(() => ({
  mainDiv: {
    height: "56vh",
    overflowY: "auto",
    overflowX: "hidden",
    "&::-webkit-scrollbar": { width: "10px" },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 5px grey",
      borderRadius: "20px",
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
}));
export default function RightbarJourney(props) {
  const { value } = props;
  const classes = useStyles();

  return (
    <>
      <Paper elevation={1}>
        <TabPanel className={classes.mainDiv} value={value} index={0}>
          <DataDisplay onEditLevelPopup={props.onEditLevelPopup} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <DataDisplay />
        </TabPanel>
        <TabPanel value={value} index={2}>
          Level3
        </TabPanel>
        <TabPanel value={value} index={3}>
          Level4
        </TabPanel>
        <TabPanel value={value} index={4}>
          Services Item
        </TabPanel>
        <TabPanel value={value} index={5}>
          Item Six
        </TabPanel>
        <TabPanel value={value} index={6}>
          Item Seven
        </TabPanel>
      </Paper>
      {/* </div> */}
    </>
  );
}
